import { useSurveyProps } from '@tm/client-form/src/hooks/useSurveyProps'
import { ThirdPartyCollectData } from '@tm/types/survey/third-party-collect'
import { isSourceInMainSegment } from '../misc/isSourceInMainSegment'

/**
 * Get the source we should redirect to after taking the survey
 *
 * The returned source will be either the matching source for mainSegmentId or
 * the first available source (or none if no sources are available).
 *
 * @return Review source to be redirected to after the survey
 */
export const useRedirectSource = (value: ThirdPartyCollectData | null | undefined) => {
  const { mainSegmentIds } = useSurveyProps()

  if (!value) return undefined

  if (mainSegmentIds) {
    const mainSegmentSource = value.sources?.find(isSourceInMainSegment(mainSegmentIds))
    if (mainSegmentSource) return mainSegmentSource
  }

  const [firstSource] = value.sources || []

  return firstSource
}
